import React from "react";
import Text from "./Text";

class Title extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enSlug: "title/en-" + props.slug,
      jpSlug: "title/jp-" + props.slug,
      jpClass: props.jpClass,
      enClass: props.enClass,
      type: props.type,
    };
  }

  render() {
    return (
      <div className="p-title__wrap" data-state={this.state.type}>
        {this.state.type !== "jp-single" && (
          <div className="p-title__wrap--en">
            <Text
              slug={this.state.enSlug}
              class={`c-text--en p-title__en c-text--main c-text--big ${this.state.enClass}`}
            />
          </div>
        )}

        {this.state.type !== "en-single" && (
          <div className="p-title__wrap--jp">
            <Text
              slug={this.state.jpSlug}
              class={`${this.state.jpClass} p-title__jp c-text--bold`}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Title;
